import { FC, useContext, useEffect, useState } from 'react';

import { PageHeader } from '../../shared/components/MainLayout/components';

import { InfoContext, UIContext } from '../../shared/contexts';
import { Typography } from 'antd';
import { CardSkeletons, ColSize, ContentSection, RowSize } from '../../shared/components';
import { PieChartHome } from './components/PieChartHome';

import './index.css'
import { TreeChartHome } from './components/TreeMapHome';
import { GenericSection } from './shared/GenericSection';
import HomeService from '../../shared/services/home';
import { BranchGroup } from '../../shared/interfaces/services/get-home-services';
import { HOME_SERVICES_VALUES } from './enums/home-services-values-enum';
import PopUpHome from './components/popUpHome';

interface HomeProps {
  title: string;
}

export const HomePage: FC<HomeProps> = () => {
  const { setTitle } = useContext(InfoContext);

  const { isLoading, showError, setIsLoading, setShowError } = useContext(UIContext);
  const [currentPolicies, setCurrentPolicies] = useState<BranchGroup[] | undefined>([]);
  const [webQuotations, setWebQuotations] = useState<BranchGroup[] | undefined>([]);
  const [claims, setClaims] = useState<BranchGroup[] | undefined>([]);
  const [claimsVsWallet, setClaimsVsWallet] = useState<BranchGroup[] | undefined>([]);


  useEffect(() => {
    setTitle('Panel de Inicio');
    getWalletInformation();
    /* eslint-disable-next-line  */
  }, []);

  const getWalletInformation = async () => {
    setIsLoading(true);
    const results = await Promise.allSettled([
      HomeService.getWebQuotations(),
      HomeService.getCurrentPolicies(),
      HomeService.getClaims(),
      HomeService.getClaimsVsWallet(),
    ]).finally(() => setIsLoading(false));

    results.forEach((result, index) => {      
      if (result.status === "fulfilled") {
        switch (index) {
          case HOME_SERVICES_VALUES.WEB_QUOTATIONS:
            if (result.value.gruposDeRama.length === 0) {
              setWebQuotations(undefined);
            } else {
              setWebQuotations(result.value.gruposDeRama);
            }
            break;
          case HOME_SERVICES_VALUES.CURRENT_POLICIES:
            if (result.value.gruposDeRama.length === 0) {
              setCurrentPolicies(undefined);
            } else {
              setCurrentPolicies(result.value.gruposDeRama);
            }
            break;
          case HOME_SERVICES_VALUES.CLAIMS:
            if (result.value.gruposDeRama.length === 0) {
              setClaims(undefined);
            } else {
              setClaims(result.value.gruposDeRama);
            }
            break;
          case HOME_SERVICES_VALUES.CLAIMS_VS_WALLET:
            if (result.value.gruposDeRama.length === 0) {
              setClaimsVsWallet(undefined);
            } else {
              setClaimsVsWallet(result.value.gruposDeRama);
            }
            break;
        }
      }
    });
  };

  return (
    <div className='home-dashboard'>
      <PageHeader />
      <RowSize>      
          <ContentSection>
            <div className='home-dashboard__support-container'>
              <Typography.Text className='home-dashboard__text-support'> <b>Ante cualquier duda en IT</b>, contactanos por WhatsApp o teléfono al <b>+54 9 11 2619-4234</b>, de lunes a viernes de 8:30 a 17 hs.</Typography.Text>
            </div>
          </ContentSection>
        <ColSize colProps={{lg:{span: 24}, xl:{span: 8}}} size={100}>
          <ContentSection >
            <div className='home-dashboard__pie-chart-container'>
              <Typography.Text className='home-dashboard__text-pie'>Cartera Vigente</Typography.Text>
              <PieChartHome />
            </div>
          </ContentSection>
        </ColSize>

        <ColSize colProps={{lg:{span: 24}, xl:{span: 16}}} size={100}>
          <ContentSection>
            <div className='home-dashboard__tree-chart-container'>
              <Typography.Text className='home-dashboard__text-tree'>Producción Vigente</Typography.Text>
              <div className='home-dashboard__tree-chart'>
                <TreeChartHome />
              </div>
            </div>
          </ContentSection>
        </ColSize>

        {
          isLoading ? <CardSkeletons /> : 
            <>
              <ColSize size={50}>
                <GenericSection color={'default'} title="Pólizas vigentes" values={currentPolicies} />
                <GenericSection color={'default'} title="% Cotizaciones web" values={webQuotations} />
              </ColSize>

              <ColSize size={50}>
                <GenericSection color={'ochre'} title="Siniestros denunciados" values={claims} />
                <GenericSection color={'ochre'} title="% Siniestros denunciados vs Cartera vigente" values={claimsVsWallet} />
              </ColSize> 
            </>
        }
        <PopUpHome />
      </RowSize>
    </div>
  );
};
